<template>
  <v-dialog v-model="dialog" scrollable max-width="300px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="lead-bottom-control-panel__btn" color="primary" dark v-bind="attrs" v-on="on">
        <v-icon color="white">mdi-account</v-icon>
        <span class="lead-bottom-control-panel__item-text">Agent</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Select Agent</v-card-title>
      <v-divider />
      <v-card-text style="height: 300px">
        <v-radio-group v-model="userId" column>
          <v-radio :value="0" label="Without Agent" />
          <v-radio
            v-for="suitableAgent in suitableAgents"
            :label="suitableAgent.email"
            :value="suitableAgent.id"
            :key="suitableAgent.id"
          />
        </v-radio-group>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="agentHandler"> Assign </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AsignmentAgentDialog",
  data() {
    return {
      dialog: false,
      userId: 0,
    };
  },
  mounted() {
    this.userId = this.lead.user_id == null ? 0 : this.lead.user_id;
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    agentHandler() {
      this.dialog = false;
      this.$socket.emit("assign-agent", this.lead.id, this.userId);
    },
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      suitableAgents: "agents/suitableAgents",
    }),
  },
};
</script>